module.exports = __webpack_public_path__ + "img/asset.efa70c85.png";